"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _en = _interopRequireDefault(require("i2l?query=sporks!i18n-data/data/locales/en"));

var _default = function _default(Provider) {
  return Provider.register(_en.default);
};

exports.default = _default;
module.exports = exports.default;